import { render, staticRenderFns } from "./add_edit.vue?vue&type=template&id=60b57f34&scoped=true&"
import script from "./add_edit.vue?vue&type=script&lang=js&"
export * from "./add_edit.vue?vue&type=script&lang=js&"
import style0 from "./add_edit.vue?vue&type=style&index=0&id=60b57f34&prod&lang=scss&scoped=true&"
import style1 from "./add_edit.vue?vue&type=style&index=1&id=60b57f34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b57f34",
  null
  
)

export default component.exports